import { render, staticRenderFns } from "./RoomsItemCard.vue?vue&type=template&id=f181b558&scoped=true"
import script from "./RoomsItemCard.vue?vue&type=script&lang=js"
export * from "./RoomsItemCard.vue?vue&type=script&lang=js"
import style0 from "./RoomsItemCard.vue?vue&type=style&index=0&id=f181b558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f181b558",
  null
  
)

export default component.exports